import axios from 'axios';

import {
    FOLLOWUP_CENTRE_LIST_REQUEST,
    FOLLOWUP_CENTRE_LIST_SUCCESS,
    FOLLOWUP_CENTRE_LIST_FAIL,

    FOLLOWUP_CENTRE_DETAILS_REQUEST,
    FOLLOWUP_CENTRE_DETAILS_SUCCESS,
    FOLLOWUP_CENTRE_DETAILS_FAIL,

    FOLLOWUP_CENTRE_DELETE_REQUEST,
    FOLLOWUP_CENTRE_DELETE_SUCCESS,
    FOLLOWUP_CENTRE_DELETE_FAIL,

    FOLLOWUP_CENTRE_CREATE_REQUEST,
    FOLLOWUP_CENTRE_CREATE_SUCCESS,
    FOLLOWUP_CENTRE_CREATE_FAIL,

    FOLLOWUP_CENTRE_UPDATE_REQUEST,
    FOLLOWUP_CENTRE_UPDATE_SUCCESS,
    FOLLOWUP_CENTRE_UPDATE_FAIL,

    FOLLOWUP_CENTRE_REQUEST,
    FOLLOWUP_CENTRE_FAIL,
    FOLLOWUP_CENTRE_RESET,
    FOLLOWUP_CENTRE_SUCCESS,

    FOLLOWUP_CENTRE_COUNT_SUCCESS,
    FOLLOWUP_CENTRE_COUNT_REQUEST,
    FOLLOWUP_CENTRE_COUNT_FAIL,

    FOLLOWUP_CENTRE_LIST_BYIDS_REQUEST,
    FOLLOWUP_CENTRE_LIST_BYIDS_SUCCESS,
    FOLLOWUP_CENTRE_LIST_BYIDS_FAIL,
    FOLLOWUP_CENTRE_LIST_BYIDS_RESET,

    SET_CURRENT_PAGE,
    

} from "../constants/followupCentreConstants";

// use dispatch to dispatch the request and throw it into the reducer
export const listFollowupCentres = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: FOLLOWUP_CENTRE_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        // get the filter
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            params
        }
        const { data } = await axios.get('/api/v1/followupCentre/all', config);

        dispatch({
            type: FOLLOWUP_CENTRE_LIST_SUCCESS,
            payload: data
        });


    } catch (error) {

        dispatch({
            type: FOLLOWUP_CENTRE_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : "An error occured, please try again later followupCentres",
        });
    }
}

export const listFollowupCentresByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: FOLLOWUP_CENTRE_LIST_BYIDS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.post('/api/v1/followupcentre/ids/all', ids, config);

        dispatch({
            type: FOLLOWUP_CENTRE_LIST_BYIDS_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: FOLLOWUP_CENTRE_LIST_BYIDS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : "An error occurred, please try again later follow-up centres",
        });
    }
}

// count followupCentres
export const countFollowupCentres = () => async (dispatch, getState) => {
    try {
      dispatch({ type: FOLLOWUP_CENTRE_COUNT_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`
        },
      }
      const { data } = await axios.get('/api/v1/followupCentre/count', config);
  
      dispatch({
        type: FOLLOWUP_CENTRE_COUNT_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch({
        type: FOLLOWUP_CENTRE_COUNT_FAIL,
        payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : "Failed to fetch followupCentre counts",
      });
    }
  }
  


export const getFollowupCentreDetails = (_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: FOLLOWUP_CENTRE_DETAILS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`/api/v1/followupCentre/${_id}`, config);

        dispatch({
            type: FOLLOWUP_CENTRE_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: FOLLOWUP_CENTRE_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}

export const deleteFollowupCentre = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: FOLLOWUP_CENTRE_DELETE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.delete(
            `/api/v1/followupCentre/${_id}/`,
            config
        )

        dispatch({
            type: FOLLOWUP_CENTRE_DELETE_SUCCESS,
        })


    } catch (error) {
        dispatch({
            type: FOLLOWUP_CENTRE_DELETE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const createFollowupCentre = (changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: FOLLOWUP_CENTRE_CREATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const data = await axios.post(
            `/api/v1/followupCentre/`,
            changes,
            config
        )

        dispatch({
            type: FOLLOWUP_CENTRE_CREATE_SUCCESS,
            payload: data,
        })


    } catch (error) {
        dispatch({
            type: FOLLOWUP_CENTRE_CREATE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
const loadFollowupCentreBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
};

// make followupCentre using a local followupCentre
export const makeFollowupCentre = (file, followupCentreId, apiEndPoint, apiKey) => async (dispatch, getState) => {

    const followupCentre = await loadFollowupCentreBase64(file);
    const followupCentre_input = JSON.stringify({ "followupCentre": followupCentre });
    const {
        userLogin: { userInfo },
    } = getState()

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`
        }
    }

    const data = await axios.post(
        apiEndPoint,
        followupCentre_input,
        config
    )
    try {
        dispatch({
            type: FOLLOWUP_CENTRE_RESET
        })
        await axios({
            method: "POST",
            url: apiEndPoint,

            data: JSON.stringify({ "data": followupCentre }),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        }).then((response) => {
                dispatch({
                    type: FOLLOWUP_CENTRE_SUCCESS
                });
                if (followupCentreId && response.data) {
                    dispatch(updateFollowupCentre(followupCentreId, { followupCentre: response.data }));
                }
            })
            .catch(function (error) {
                dispatch({
                    type: FOLLOWUP_CENTRE_FAIL
                });
                console.log(error.message);
            });
    }

    catch (error) {
        dispatch({
            type: FOLLOWUP_CENTRE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }

}


export const updateFollowupCentre = (_id, changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: FOLLOWUP_CENTRE_UPDATE_REQUEST
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const response = await axios.patch(
            `/api/v1/followupCentre/${_id}/`,
            changes,
            config
        );

        dispatch({
            type: FOLLOWUP_CENTRE_UPDATE_SUCCESS,
            payload: response.data, // Assuming the updated followupCentre data is returned
        });

        dispatch({
            type: FOLLOWUP_CENTRE_DETAILS_SUCCESS,
            payload: response.data, // Assuming the updated followupCentre data is returned
        });
    } catch (error) {
        let errorPayload = [];

        if (error.response && error.response.status === 400 && error.response.data.errors) {
            const validationErrors = error.response.data.errors;
            // Concatenate detailed validation errors to the error payload array
            errorPayload = Object.values(validationErrors).flat();
        }

        // Include generic error message or additional error data in the payload array
        if (error.response && error.response.data.detail) {
            errorPayload.push(error.response.data.detail);
        } else {
            errorPayload.push(error.message);
        }

        dispatch({
            type: FOLLOWUP_CENTRE_UPDATE_FAIL,
            payload: errorPayload,
        });
    }
};
